import { useEffect } from "react";

import { PreloadedQuery, usePreloadedQuery } from "react-relay";
import {
    AnchorPageRelayQuery,
    shapeAnchorContentfulResponse
} from "src/contentful";

import { anchorPageRelayQuery } from "@/__generated_contentful__/anchorPageRelayQuery.graphql";
import { PaidLandingPersonaTypes } from "@/utils/anchor-queries/get-anchor-contents";
import { AnchorContentsResponse } from "@/utils/anchor-queries/get-anchor-contents";
import { experiments, useExperimentExposure } from "@/utils/experiment";
import { FeatureExposed } from "@/utils/feature-exposed";

import { ConfluenceSoftwarePageProps } from "./confluence-software-page";
import { getPageId } from "./keywords/keyword-util";
import { ConfluencePagePaidLpConflAnchor } from "./paid-lp-confl-anchor";
import { isTargetedSubAnchor } from "./subAnchors/subAnchor-util.tsx";

export interface ConfluencePageKeywordRelayProps
    extends ConfluenceSoftwarePageProps {
    anchorContents?: AnchorContentsResponse | null;
    queryRef?: PreloadedQuery<anchorPageRelayQuery>;
}

export const ConfluenceSoftwarePageVariantPaidLpConfKeywordsRelay = (
    pageProps: ConfluencePageKeywordRelayProps
) => {
    const [cpapiDeprecationExposureFired, fireCpapiDeprecationExposure] =
        useExperimentExposure(experiments.cpapiDeprecationConfExperiment);
    const [exposureSubAnchorFired, fireSubAnchorExposure] =
        useExperimentExposure(experiments.cfind3254LandingPageSubAnchor);
    useEffect(() => {
        if (
            isTargetedSubAnchor(pageProps.subAnchor) &&
            !exposureSubAnchorFired
        ) {
            fireSubAnchorExposure();
        }
        if (!cpapiDeprecationExposureFired) {
            fireCpapiDeprecationExposure();
        }
    }, [
        exposureSubAnchorFired,
        fireSubAnchorExposure,
        cpapiDeprecationExposureFired,
        fireCpapiDeprecationExposure
    ]);

    const data = usePreloadedQuery(
        AnchorPageRelayQuery,
        pageProps.queryRef ||
            (null as unknown as PreloadedQuery<anchorPageRelayQuery>)
    );
    pageProps = Object.assign({}, pageProps, {
        anchorContents: shapeAnchorContentfulResponse(data)
    });

    return (
        <FeatureExposed
            experimentKey="cfind-2260-nbps-paid-anchor-journey"
            group="Test"
        >
            <ConfluencePagePaidLpConflAnchor
                {...pageProps}
                pageId={getPageId(pageProps.keyword)}
                persona={"unknown" as PaidLandingPersonaTypes}
                pageVariant="keywords"
                dataProductKey="confluence-PaidLpConflKeywords"
            />
        </FeatureExposed>
    );
};
